const newCustomResourceStatistic = () =>
  import('@/views/main/newCustomResource/statistic/Statistic.vue')
export default {
  path: '/main/newCustomResource/statistic',
  name: 'newCustomResourceStatistic',
  component: newCustomResourceStatistic,
  children: []
}
